import styled from "styled-components";

const RowColSpan = styled.span`
    grid-column-start: ${({ gridColumnStart }) => gridColumnStart};
    grid-row-start: ${({ gridRowStart }) => gridRowStart};
    ${({ maxWidth }) => maxWidth != null ? `max-width: ${maxWidth};` : ""}
`;

export default RowColSpan;